module.exports = __webpack_public_path__ + "static/img/gx.7f6ab71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s32/gx.png
// module id = fqU9
// module chunks = 2